import { ApiRequest } from '../baseService'

const BaseRoute = 'app/reminder-schedule'

function getDefinitions() {
  return ApiRequest.get(`${BaseRoute}/definitions`)
}

function simulate(data) {
  return ApiRequest.post(`${BaseRoute}/simulate`, data)
}

function exportExcel(data) {
  return ApiRequest.post(`${BaseRoute}/export`, data, {
    responseType: 'arraybuffer',
  })
}

const API = {
  getDefinitions,
  simulate,
  exportExcel,
}

export default API
